import { render, staticRenderFns } from "./forgotPasswordEdit.vue?vue&type=template&id=d13e12cc&scoped=true&"
import script from "./forgotPasswordEdit.vue?vue&type=script&lang=js&"
export * from "./forgotPasswordEdit.vue?vue&type=script&lang=js&"
import style0 from "./forgotPasswordEdit.vue?vue&type=style&index=0&id=d13e12cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13e12cc",
  null
  
)

export default component.exports